var _a;
// 手机型号 reg
var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|Vivo|Oppo|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|global.windows (ce|phone)|xda|xiino/i;
// userAgent
var UA_LOWERCASE = (_a = global.navigator) === null || _a === void 0 ? void 0 : _a.userAgent.toLowerCase();
var isMobile = function () { return mobileRE.test(UA_LOWERCASE); };
var BaseUrl;
(function (BaseUrl) {
    BaseUrl["mobile"] = "https://plogin.m.jd.com/user/login.action";
    BaseUrl["pc"] = "https://passport.jd.com/uc/login";
})(BaseUrl || (BaseUrl = {}));
// URL处理
var getReturnUrl = function (url) {
    var returnUrl = url || global.window.location.href;
    returnUrl =
        returnUrl.indexOf("?") > -1
            ? "".concat(returnUrl, "&yyjdfromflag=login")
            : "".concat(returnUrl, "?yyjdfromflag=login");
    returnUrl = encodeURIComponent(returnUrl);
    return returnUrl;
};
var DOMAIN_LIST = [
    {
        re: new RegExp(".*\\.(jd)\\.com.*$"),
        appid: "300", // 无APPID,无需数据统计，可使用默认APPID：300/100  100是京东商城APP用的
    },
    {
        re: new RegExp(".*\\.(healthjd)\\.com.*$"),
        appid: "445",
    },
    { re: new RegExp(".*\\.(yiyaojd)\\.com.*$"), appid: "270" },
];
// 判断是否互医小程序
export var isNethpMiniProgram = function () {
    return global.window.sessionStorage.getItem("miniprogram") === "nethp";
};
// 跳转登录
export var toLogin = function (url) {
    var _a, _b, _c;
    // 判断是否为互医小程序
    if (isNethpMiniProgram()) {
        (_b = (_a = global.window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.redirectTo({
            url: "/pages/login/index/index?returnPage=".concat(encodeURIComponent(url || global.window.location.href), "&pageType=h5"),
        });
        return;
    }
    var returnUrl = getReturnUrl(url);
    var host = (_c = global.window.location) === null || _c === void 0 ? void 0 : _c.host;
    var path = "".concat(BaseUrl.pc, "?ReturnUrl=").concat(returnUrl);
    // 判断是否是手机环境打开
    if (isMobile()) {
        DOMAIN_LIST.map(function (item) {
            if (item.re.test(host)) {
                path = "".concat(BaseUrl.mobile, "?appid=").concat(item.appid, "&returnurl=").concat(returnUrl);
            }
        });
        for (var i = 0; i < DOMAIN_LIST.length; i += 1) {
            var element = DOMAIN_LIST[i];
            if (element.re.test(host)) {
                path = "".concat(BaseUrl.mobile, "?appid=").concat(element.appid, "&returnurl=").concat(returnUrl);
                break;
            }
        }
    }
    global.window.location.replace(path);
};
export var responseToLogin = function (response, code, path) {
    // 兼容array
    if (Object.prototype.toString.call(code) === "[object Array]") {
        if (code.includes(response.data.code)) {
            toLogin(path || global.window.location.href);
        }
    }
    else if (response.data.code === code) {
        toLogin(path || global.window.location.href);
    }
    return response;
};
